/* tslint:disable */
/* eslint-disable */
import * as runtime from '../runtime';
import type { PackageClaim } from '../models/index';
import {
    PackageClaimFromJSON,
    PackageClaimToJSON,
} from '../models/index';
import type { CourierPackage } from '../models/index';
import {
    CourierPackageFromJSON,
} from '../models/index';

export interface PackageClaimGetUnknownPackagesRequest {
    warehouseCourierId: number;
}

export interface PackageClaimCreateClaimRequest {
    data: {
        packageId: number;
        claimantCourierId: number;
        claimantUserId: number;
        warehouseCourierId: number;
        invoiceFile?: string[];
        notes?: string;
        recipientUserId?: number;
        recipientName?: string;
    };
}

export interface PackageClaimReviewClaimRequest {
    data: {
        claimId: number;
        status: 'approved' | 'rejected';
        reviewNotes?: string;
        reviewedBy: number;
    };
}

export interface PackageClaimGetClaimsForPackageRequest {
    packageId: number;
}

export interface PackageClaimGetMyClaimsRequest {
    claimantCourierId: number;
}

export interface PackageClaimAssignPackageRequest {
    data: {
        packageId: number;
        subCourierId: number;
        warehouseCourierId: number;
        assignedBy: number;
        notes?: string;
        recipientUserId?: number;
    };
}

export class PackageClaimApi extends runtime.BaseAPI {

    async getUnknownPackagesRaw(requestParameters: PackageClaimGetUnknownPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourierPackage>>> {
        if (requestParameters['warehouseCourierId'] == null) {
            throw new runtime.RequiredError('warehouseCourierId', 'Required parameter "warehouseCourierId" was null or undefined when calling getUnknownPackages().');
        }

        const queryParameters: any = {};
        queryParameters['warehouseCourierId'] = requestParameters['warehouseCourierId'];

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/PackageClaims/unknown-packages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourierPackageFromJSON));
    }

    async getUnknownPackages(requestParameters: PackageClaimGetUnknownPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourierPackage>> {
        const response = await this.getUnknownPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async createClaimRaw(requestParameters: PackageClaimCreateClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PackageClaim>> {
        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError('data', 'Required parameter "data" was null or undefined when calling createClaim().');
        }

        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PackageClaims/create-claim`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['data'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PackageClaimFromJSON(jsonValue));
    }

    async createClaim(requestParameters: PackageClaimCreateClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PackageClaim> {
        const response = await this.createClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async reviewClaimRaw(requestParameters: PackageClaimReviewClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PackageClaim>> {
        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError('data', 'Required parameter "data" was null or undefined when calling reviewClaim().');
        }

        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PackageClaims/review-claim`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['data'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PackageClaimFromJSON(jsonValue));
    }

    async reviewClaim(requestParameters: PackageClaimReviewClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PackageClaim> {
        const response = await this.reviewClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async getClaimsForPackageRaw(requestParameters: PackageClaimGetClaimsForPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PackageClaim>>> {
        if (requestParameters['packageId'] == null) {
            throw new runtime.RequiredError('packageId', 'Required parameter "packageId" was null or undefined when calling getClaimsForPackage().');
        }

        const queryParameters: any = {};
        queryParameters['packageId'] = requestParameters['packageId'];

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/PackageClaims/claims-for-package`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PackageClaimFromJSON));
    }

    async getClaimsForPackage(requestParameters: PackageClaimGetClaimsForPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PackageClaim>> {
        const response = await this.getClaimsForPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async getMyClaimsRaw(requestParameters: PackageClaimGetMyClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PackageClaim>>> {
        if (requestParameters['claimantCourierId'] == null) {
            throw new runtime.RequiredError('claimantCourierId', 'Required parameter "claimantCourierId" was null or undefined when calling getMyClaims().');
        }

        const queryParameters: any = {};
        queryParameters['claimantCourierId'] = requestParameters['claimantCourierId'];

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/PackageClaims/my-claims`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PackageClaimFromJSON));
    }

    async getMyClaims(requestParameters: PackageClaimGetMyClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PackageClaim>> {
        const response = await this.getMyClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async assignPackageRaw(requestParameters: PackageClaimAssignPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PackageClaim>> {
        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError('data', 'Required parameter "data" was null or undefined when calling assignPackage().');
        }

        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/PackageClaims/assign-package`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['data'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PackageClaimFromJSON(jsonValue));
    }

    async assignPackage(requestParameters: PackageClaimAssignPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PackageClaim> {
        const response = await this.assignPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
